import { useState } from "react";
import { message } from "antd";
import {
  createZone,
  deleteZoneApi,
  getZonesWithSection,
  updateZone,
} from "../../../api/zone/zoneRequest";

export const useZoneManagement = (form) => {
  const [zones, setZones] = useState([]);
  const [currentZone, setCurrentZone] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [drawingMode, setDrawingMode] = useState(false);
  const [editingZone, setEditingZone] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [zoomToZone, setZoomToZone] = useState(null);

  const fetchZones = async () => {
    try {
      setLoading(true);
      const data = await getZonesWithSection();
      setZones(data);
    } catch (error) {
      message.error("Échec de la récupération des zones");
    } finally {
      setLoading(false);
    }
  };

  const handlePolygonComplete = (data) => {
    setCurrentZone(data);
    setIsModalVisible(true);
    setDrawingMode(false);
  };

  const startEditingZone = (zone) => {
    setEditingZone({
      ...zone,
      coordinates: [...zone.coordinates],
    });
    setCurrentZone({
      coordinates: [...zone.coordinates],
    });
    setIsEditing(true);
    setDrawingMode(false);
  };

  const handlePolygonEdit = (newCoordinates) => {
    setCurrentZone((prev) => ({
      ...prev,
      coordinates: [...newCoordinates],
    }));
    setEditingZone((prev) => ({
      ...prev,
      coordinates: [...newCoordinates],
    }));
  };

  const handleViewZone = (zone) => {
    setZoomToZone(zone);
    setTimeout(() => setZoomToZone(null), 1000);
  };

  const cancelEditing = () => {
    setEditingZone(null);
    setCurrentZone(null);
    setIsEditing(false);
    setDrawingMode(true);
    form.resetFields();
    fetchZones();
  };

  const handleSave = async (values) => {
    if (!currentZone) {
      message.warning("Veuillez d'abord dessiner une zone");
      return;
    }    const zoneData = {
      name: values.name,
      prefix: values.prefix,
      description: values.description,
      coordinates: currentZone.coordinates,
    };

    try {
      setLoading(true);
      if (editingZone) {
        await updateZone(editingZone.id, zoneData);
        message.success("Zone mise à jour avec succès");
      } else {
        await createZone(zoneData);
        message.success("Zone créée avec succès");
      }

      await fetchZones();
      handleModalClose();
    } catch (error) {
      message.error(
        editingZone
          ? "Échec de la mise à jour de la zone"
          : "Échec de l'enregistrement de la zone"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setCurrentZone(null);
    setEditingZone(null);
    setIsEditing(false);
    setDrawingMode(true);
    form.resetFields();
  };

  const deleteZone = async (zoneId) => {
    try {
      setLoading(true);
      await deleteZoneApi(zoneId);
      message.success("Zone supprimée avec succès");
      await fetchZones();
    } catch (error) {
      message.error("Échec de la suppression de la zone");
    } finally {
      setLoading(false);
    }
  };

  return {
    zones,
    currentZone,
    isModalVisible,
    loading,
    drawingMode,
    editingZone,
    isEditing,
    zoomToZone,
    fetchZones,
    handlePolygonComplete,
    startEditingZone,
    handlePolygonEdit,
    handleViewZone,
    cancelEditing,
    handleSave,
    handleModalClose,
    deleteZone,
    setDrawingMode,
    setIsModalVisible,
  };
};
